// ГЕНЕРИРАН от scripts/generate_palettes.py — не редактирай на ръка.
// Копие на цветовете на всяка тема за мострите в модала „Тема“ и antd
// token-ите (те не четат var()); истината е в CSS-а (src/index.css и
// src/styles/palettes/), а themePalettes.test.ts пази двете в синхрон.
import type { ThemeMode } from "../api/configuration";
import type { ThemePaletteColors } from "./themePalettes";

export const THEME_PALETTE_VALUES: Record<ThemeMode, ThemePaletteColors> = {
  light: {
    canvas: "#F4F2ED",
    surface: "#FFFFFF",
    border: "#E8E1D6",
    inactive: "#EFEBE3",
    ink: "#1A1A1A",
    muted: "#8A8A8F",
    accent: "#D97706",
    accentHover: "#B45309",
    accentText: "#B45309",
    tint: "#FFF4E0",
    tintBorder: "#FEE8C4",
    posAccent: "#C97C2C",
  },
  dark: {
    canvas: "#171310",
    surface: "#231E18",
    border: "#363028",
    inactive: "#191613",
    ink: "#ECE7DF",
    muted: "#968E81",
    accent: "#D97706",
    accentHover: "#B45309",
    accentText: "#F0A640",
    tint: "#382A12",
    tintBorder: "#54401E",
    posAccent: "#C97C2C",
    elevated: {
      surface: "#332B22",
      border: "#453D32",
      borderSecondary: "#38312A",
    },
  },
  green: {
    canvas: "#EEF4EE",
    surface: "#FFFFFF",
    border: "#DAE6DB",
    inactive: "#E6EEE7",
    ink: "#131D14",
    muted: "#828F82",
    accent: "#2F8A4E",
    accentHover: "#24733F",
    accentText: "#237040",
    tint: "#E6F3E8",
    tintBorder: "#BEDFC6",
    posAccent: "#2F8A4E",
  },
  "green-dark": {
    canvas: "#111511",
    surface: "#1A211A",
    border: "#2B342B",
    inactive: "#141814",
    ink: "#E2EAE2",
    muted: "#869486",
    accent: "#2F8A4E",
    accentHover: "#24733F",
    accentText: "#70CF8B",
    tint: "#1D3222",
    tintBorder: "#2E4C35",
    posAccent: "#2F8A4E",
    elevated: {
      surface: "#253026",
      border: "#364236",
      borderSecondary: "#2C352D",
    },
  },
  sky: {
    canvas: "#EEF3F8",
    surface: "#FFFFFF",
    border: "#DAE3ED",
    inactive: "#E6ECF3",
    ink: "#0E1B29",
    muted: "#7F8C9B",
    accent: "#1F7FC0",
    accentHover: "#17699F",
    accentText: "#17699F",
    tint: "#E4F1FB",
    tintBorder: "#B7D8F1",
    posAccent: "#1F7FC0",
  },
  "sky-dark": {
    canvas: "#101419",
    surface: "#192027",
    border: "#29323C",
    inactive: "#13171B",
    ink: "#E0E9F2",
    muted: "#8391A0",
    accent: "#1F7FC0",
    accentHover: "#17699F",
    accentText: "#71BFFE",
    tint: "#1A2F40",
    tintBorder: "#29475F",
    posAccent: "#1F7FC0",
    elevated: {
      surface: "#232E39",
      border: "#34404D",
      borderSecondary: "#2B333D",
    },
  },
  cream: {
    canvas: "#F8F1E7",
    surface: "#FFFFFF",
    border: "#EBE1CF",
    inactive: "#F2EADD",
    ink: "#20190D",
    muted: "#938979",
    accent: "#96703A",
    accentHover: "#7D5D2F",
    accentText: "#7D5D2F",
    tint: "#F4EBDA",
    tintBorder: "#E3D0AE",
    posAccent: "#96703A",
  },
  "cream-dark": {
    canvas: "#17130D",
    surface: "#241E13",
    border: "#383022",
    inactive: "#191610",
    ink: "#EFE7D9",
    muted: "#9A8D78",
    accent: "#96703A",
    accentHover: "#7D5D2F",
    accentText: "#DAAF74",
    tint: "#352B1D",
    tintBorder: "#4F412E",
    posAccent: "#96703A",
    elevated: {
      surface: "#352B1A",
      border: "#483D29",
      borderSecondary: "#393123",
    },
  },
  violet: {
    canvas: "#F3F1F8",
    surface: "#FFFFFF",
    border: "#E3DFEF",
    inactive: "#ECEAF5",
    ink: "#1C162A",
    muted: "#8D869F",
    accent: "#6D4FC2",
    accentHover: "#5A3FA6",
    accentText: "#5A3FA6",
    tint: "#EEE9FA",
    tintBorder: "#D3C7F1",
    posAccent: "#6D4FC2",
  },
  "violet-dark": {
    canvas: "#15131A",
    surface: "#201D29",
    border: "#322E3E",
    inactive: "#17151C",
    ink: "#E9E5F4",
    muted: "#918BA3",
    accent: "#6D4FC2",
    accentHover: "#5A3FA6",
    accentText: "#B8A9FF",
    tint: "#2D2746",
    tintBorder: "#443C67",
    posAccent: "#6D4FC2",
    elevated: {
      surface: "#2E293C",
      border: "#403A50",
      borderSecondary: "#34303F",
    },
  },
  silver: {
    canvas: "#F1F2F4",
    surface: "#FFFFFF",
    border: "#DFE2E7",
    inactive: "#EAEBEF",
    ink: "#161A22",
    muted: "#858B96",
    accent: "#4F5D70",
    accentHover: "#3E4A5A",
    accentText: "#3E4A5A",
    tint: "#E9ECF0",
    tintBorder: "#C9CFD8",
    posAccent: "#4F5D70",
  },
  "silver-dark": {
    canvas: "#121417",
    surface: "#1C1F23",
    border: "#2E3137",
    inactive: "#151719",
    ink: "#E5E8ED",
    muted: "#8A8F98",
    accent: "#4F5D70",
    accentHover: "#3E4A5A",
    accentText: "#A8B9D0",
    tint: "#292D32",
    tintBorder: "#3F444C",
    posAccent: "#4F5D70",
    elevated: {
      surface: "#292D34",
      border: "#3A3F46",
      borderSecondary: "#2F3338",
    },
  },
  red: {
    canvas: "#F7F0EF",
    surface: "#FFFFFF",
    border: "#ECDFDC",
    inactive: "#F2E9E7",
    ink: "#271411",
    muted: "#998682",
    accent: "#BE3A30",
    accentHover: "#A02F27",
    accentText: "#A02F27",
    tint: "#FBE8E5",
    tintBorder: "#F0C3BC",
    posAccent: "#BE3A30",
  },
  "red-dark": {
    canvas: "#181211",
    surface: "#261C1A",
    border: "#3A2E2B",
    inactive: "#1B1514",
    ink: "#F1E4E2",
    muted: "#9E8A85",
    accent: "#BE3A30",
    accentHover: "#A02F27",
    accentText: "#FE9789",
    tint: "#44211D",
    tintBorder: "#65342D",
    posAccent: "#BE3A30",
    elevated: {
      surface: "#382825",
      border: "#4B3A36",
      borderSecondary: "#3C2F2C",
    },
  },
};
